/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import { RichText } from 'prismic-reactjs';

import BulmaSection from 'react-bulma-components/lib/components/section';
import BulmaContainer from 'react-bulma-components/lib/components/container';

import { Heading, LazyLink, LazyImage, Quote } from '../atoms';
import {
  styledCustomerContentText,
  styledCustomerDetailsItem,
  styledCustomerDetailsTerm,
  styledCustomerDetailsName,
  styledCustomerContentStickyMenu,
  styledCustomerContentContainer,
  styledCardBox,
  styledCardContent,
  styledCustomerDetails,
  styledCustomerContentBreadcrumb,
  styledCustomerContentBreadcrumbLink,
  styledCustomerContentSection,
  styledCustomerSocialLink,
  StyledHoverIcon,
  StyledEmailHoverIcon,
  styledCustomerSocialInfo,
  styledSocialInfo,
  styledCustomerProductsName,
  styledQuoteCard,
  styledQuoteCardContent,
} from './CustomerContentStyles';

import { linkResolver } from '../../util/linkResolver';

const renderButton = (link, text, atts) => (
  <LazyLink {...atts} url={link.url}>
    {text}
  </LazyLink>
);

const renderCard = (image, link) => (
  <div data-testid="card" css={styledCardBox}>
    <LazyLink url={link.url} css={styledCardContent}>
      {image && image.url ? <LazyImage src={image.url} alt={image.alt || 'customer icon'} /> : null}
    </LazyLink>
  </div>
);

const renderSocialIcons = (twitterLink, facebookLink, linkedinLink, emailLink) => (
  <div css={styledCustomerSocialInfo}>
    <div css={styledSocialInfo}>
      {twitterLink && (
        <LazyLink url={twitterLink.url} css={styledCustomerSocialLink}>
          <StyledHoverIcon>
            <path d="M16.1367 4.59375C16.8398 4.06641 17.4727 3.43359 17.9648 2.69531C17.332 2.97656 16.5938 3.1875 15.8555 3.25781C16.6289 2.80078 17.1914 2.09766 17.4727 1.21875C16.7695 1.64062 15.9609 1.95703 15.1523 2.13281C14.4492 1.39453 13.5 0.972656 12.4453 0.972656C10.4062 0.972656 8.75391 2.625 8.75391 4.66406C8.75391 4.94531 8.78906 5.22656 8.85938 5.50781C5.80078 5.33203 3.05859 3.85547 1.23047 1.64062C0.914062 2.16797 0.738281 2.80078 0.738281 3.50391C0.738281 4.76953 1.37109 5.89453 2.39062 6.5625C1.79297 6.52734 1.19531 6.38672 0.703125 6.10547V6.14062C0.703125 7.93359 1.96875 9.41016 3.65625 9.76172C3.375 9.83203 3.02344 9.90234 2.70703 9.90234C2.46094 9.90234 2.25 9.86719 2.00391 9.83203C2.46094 11.3086 3.83203 12.3633 5.44922 12.3984C4.18359 13.3828 2.60156 13.9805 0.878906 13.9805C0.5625 13.9805 0.28125 13.9453 0 13.9102C1.61719 14.9648 3.55078 15.5625 5.66016 15.5625C12.4453 15.5625 16.1367 9.97266 16.1367 5.08594C16.1367 4.91016 16.1367 4.76953 16.1367 4.59375Z" />
          </StyledHoverIcon>
        </LazyLink>
      )}
      {facebookLink && (
        <LazyLink url={facebookLink.url} css={styledCustomerSocialLink}>
          <StyledHoverIcon>
            <path d="M17.7188 9.25C17.7188 4.43359 13.8164 0.53125 9 0.53125C4.18359 0.53125 0.28125 4.43359 0.28125 9.25C0.28125 13.6094 3.44531 17.2305 7.62891 17.8633V11.7812H5.41406V9.25H7.62891V7.35156C7.62891 5.17188 8.92969 3.94141 10.8984 3.94141C11.8828 3.94141 12.8672 4.11719 12.8672 4.11719V6.26172H11.7773C10.6875 6.26172 10.3359 6.92969 10.3359 7.63281V9.25H12.7617L12.375 11.7812H10.3359V17.8633C14.5195 17.2305 17.7188 13.6094 17.7188 9.25Z" />
          </StyledHoverIcon>
        </LazyLink>
      )}
      {linkedinLink && (
        <LazyLink url={linkedinLink.url} css={styledCustomerSocialLink}>
          <StyledHoverIcon>
            <path d="M14.75 0.375H1.21484C0.617188 0.375 0.125 0.902344 0.125 1.53516V15C0.125 15.6328 0.617188 16.125 1.21484 16.125H14.75C15.3477 16.125 15.875 15.6328 15.875 15V1.53516C15.875 0.902344 15.3477 0.375 14.75 0.375ZM4.87109 13.875H2.55078V6.38672H4.87109V13.875ZM3.71094 5.33203C2.9375 5.33203 2.33984 4.73438 2.33984 3.99609C2.33984 3.25781 2.9375 2.625 3.71094 2.625C4.44922 2.625 5.04688 3.25781 5.04688 3.99609C5.04688 4.73438 4.44922 5.33203 3.71094 5.33203ZM13.625 13.875H11.2695V10.2188C11.2695 9.375 11.2695 8.25 10.0742 8.25C8.84375 8.25 8.66797 9.19922 8.66797 10.1836V13.875H6.34766V6.38672H8.5625V7.40625H8.59766C8.91406 6.80859 9.6875 6.17578 10.8125 6.17578C13.168 6.17578 13.625 7.75781 13.625 9.76172V13.875Z" />
          </StyledHoverIcon>
        </LazyLink>
      )}
      {emailLink && (
        <LazyLink url={emailLink.url} css={styledCustomerSocialLink}>
          <StyledEmailHoverIcon>
            <path d="M16.3125 0H1.6875C0.738281 0 0 0.773438 0 1.6875V11.8125C0 12.7617 0.738281 13.5 1.6875 13.5H16.3125C17.2266 13.5 18 12.7617 18 11.8125V1.6875C18 0.773438 17.2266 0 16.3125 0ZM16.3125 1.6875V3.12891C15.5039 3.79688 14.2383 4.78125 11.5664 6.89062C10.9688 7.34766 9.80859 8.47266 9 8.4375C8.15625 8.47266 6.99609 7.34766 6.39844 6.89062C3.72656 4.78125 2.46094 3.79688 1.6875 3.12891V1.6875H16.3125ZM1.6875 11.8125V5.30859C2.46094 5.94141 3.62109 6.85547 5.34375 8.22656C6.11719 8.82422 7.48828 10.1602 9 10.125C10.4766 10.1602 11.8125 8.82422 12.6211 8.22656C14.3438 6.85547 15.5039 5.94141 16.3125 5.30859V11.8125H1.6875Z" />
          </StyledEmailHoverIcon>
        </LazyLink>
      )}
    </div>
  </div>
);

const renderQuote = input =>
  input.map(items => (
    <div css={styledQuoteCard}>
      <div css={styledQuoteCardContent}>
        <Quote quoteProps={{ ...items }} />
      </div>
    </div>
  ));

const renderHeading = (text, atts) => <Heading {...atts}>{text.text}</Heading>;

const CustomerContent = ({ input }) => {
  const {
    background_image,
    background_color,
    breadcrumb,
    logo,
    copy1,
    copy1_text,
    copy2,
    copy2_text,
    copy3,
    copy3_text,
    copy4,
    copy4_text,
    products,
    products_text,
    content,
    content2,
    logo_link,
    button_text,
    button_link,
    twitter_link,
    facebook_link,
    linkedin_link,
    email_link,
    button_color,
    text_color,
    heading,
    heading_color,
  } = input.primary;

  return (
    <BulmaSection
      css={styledCustomerContentSection}
      style={
        background_image && background_image.url
          ? { backgroundImage: `url(${background_image.url})` }
          : { backgroundColor: `${background_color}` }
      }
    >
      {heading
        ? renderHeading(heading[0], {
            renderAs: 'h2',
            className: `${text_color === 'light' && !heading_color ? 'h2 white' : 'h2 darkblue'}`,
            style: { color: heading_color },
          })
        : null}
      <BulmaContainer>
        <div css={styledCustomerContentContainer}>
          <div css={styledCustomerContentText}>
            <LazyLink css={styledCustomerContentBreadcrumbLink} url="https://www.digitalocean.com/customers">
              Customer Stories
            </LazyLink>
            <span id="testCustomerContentBreadcrumb" css={styledCustomerContentBreadcrumb}>
              {breadcrumb}
            </span>
            <div id="testCustomerContent" style={text_color === 'light' ? { color: 'white' } : null}>
              {content && content[0] ? <RichText render={content} linkResolver={linkResolver} /> : null}
              {input.fields[0].quote === null ? null : renderQuote(input.fields)}
              {content2 && content2[0] ? <RichText render={content2} linkResolver={linkResolver} /> : null}
            </div>
          </div>
          <div id="testCustomerContentMenu" css={styledCustomerContentStickyMenu}>
            {renderCard(logo, logo_link)}
            <dl css={styledCustomerDetails}>
              <div css={styledCustomerDetailsItem}>
                <dt css={styledCustomerDetailsTerm}>{copy1}</dt>
                <dd css={styledCustomerDetailsName}>{copy1_text}</dd>
              </div>
              <div css={styledCustomerDetailsItem}>
                <dt css={styledCustomerDetailsTerm}>{copy2}</dt>
                <dd css={styledCustomerDetailsName}>{copy2_text}</dd>
              </div>
              <div css={styledCustomerDetailsItem}>
                <dt css={styledCustomerDetailsTerm}>{copy3}</dt>
                <dd css={styledCustomerDetailsName}>{copy3_text}</dd>
              </div>
              <div css={styledCustomerDetailsItem}>
                <dt css={styledCustomerDetailsTerm}>{copy4}</dt>
                <dd css={styledCustomerDetailsName}>{copy4_text}</dd>
              </div>
              <div css={styledCustomerDetailsItem}>
                <dt css={styledCustomerDetailsTerm}>{products}</dt>
                <dd css={styledCustomerProductsName}>
                  <RichText render={products_text} linkResolver={linkResolver} />
                </dd>
              </div>
              {button_text &&
                renderButton(button_link, button_text, {
                  className: `${
                    button_color === 'white' ? 'button-link is-white is-outlined' : 'button-link is-outlined'
                  }`,
                })}
            </dl>
            {twitter_link || facebook_link || linkedin_link || email_link
              ? renderSocialIcons(twitter_link, facebook_link, linkedin_link, email_link)
              : null}
          </div>
        </div>
      </BulmaContainer>
    </BulmaSection>
  );
};
export default CustomerContent;

CustomerContent.propTypes = {
  input: PropTypes.object.isRequired,
};
